export interface Catalogue {
  name: string;
  description: string;
  slug: string;
  updated_at: string;
  created_at: string;
  id: number;
  items_count: number;
  items: any[];
  message: string;
  status: boolean;
}

export interface CatalogueResponseFromApi {
  count: number;
  data: Array<Catalogue>;
  end: boolean;
  next: null | number;
  prev: null | number;
  message: string,
  status: boolean;
}

export const CataloguePictures = () => ({
  data: [
    "../../../assets/images/Category_pictures/beauty.jpg",
    "../../../assets/images/Category_pictures/footwear.jpg",
    "../../../assets/images/Category_pictures/officeEquipment.jpg",
    "../../../assets/images/Category_pictures/plastics.jpg",
    "../../../assets/images/Category_pictures/fitnessAndHealth.jpg",
    "../../../assets/images/Category_pictures/perfumes.jpg",
    "../../../assets/images/Category_pictures/computers.jpg",
    "../../../assets/images/Category_pictures/furniture.jpg",
    "../../../assets/images/Category_pictures/appliances.jpg",
    "../../../assets/images/Category_pictures/cosmetics.jpg",
    "../../../assets/images/Category_pictures/jewelry.jpg"
  ]
});
